<template>
	<div class="datePicked">
		<div class="resetButtton" v-show="startTime.time" v-on:click="reset"><i class="fa fa-times-circle"></i></div>
		<date-picker :date="startTime" :option="timeoption" ></date-picker>
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    import Datepicker from 'vue-datepicker/vue-datepicker-es6.vue';

    export default {
        name: 'vfg-field-datepicker',
        mixins: [ abstractField ],
        watch: {
            'startTime.time' () {
                this.value = this.startTime.time;
            }
        },
        data () {
            return {
                // for Vue 1.0
                starttime: this.value,
                endtime: '2016-01-19',
                testTime: '',
                multiTime: '',

                // for Vue 2.0
                startTime: {
                    time: ''
                },
                endtime: {
                    time: ''
                },
                option: {
                    type: 'day',
                    week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format: 'YYYY-MM-DD HH:MM',
                    placeholder: 'when?',
                    inputClass: 'form-control',
                    color: {
                        header: '#ccc',
                        headerText: '#f00'
                    },
                    buttons: {
                        ok: 'Ok',
                        cancel: 'Cancel'
                    },
                    overlayOpacity: 0.5, // 0.5 as default
                    dismissible: true // as true as default
                },
                timeoption: {
                    type: 'min',
                    inputClass: 'form-control',
                    week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format: 'YYYY-MM-DD HH:MM',
                    inputStyle: {
                        'width': '100%',
                        'display': 'block',
                        'padding': '6px 12px',
                        'line-height': '1.42857143',
                        'font-size': '14px',
	                    'border': 'none',
                        'border-bottom': '2px solid #c9b3db ',
                        'color': '#5F5F5F',
	                    'background': 'transparent'
                    }
                },
                multiOption: {
                    type: 'multi-day',
                    week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format:"YYYY-MM-DD HH:MM"
                },
                limit: [{
                    type: 'weekday',
                    available: [1, 2, 3, 4, 5]
                },
                    {
                        type: 'fromto',
                        from: '2016-02-01',
                        to: '2016-02-20'
                    }]
            }
        },
	    methods: {
            reset () {
                this.value = '';
                this.startTime.time = '';
            }
	    },
        components: {
            'date-picker': Datepicker
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.cov-vue-date {
		display: block;
		color: #5D5D5D;
		float: left;
		width: 100%;
	}
	.cov-vue-date .datepickbox{

		width: 100%;
	}
	.cov-date-body {
		font-family: -apple-system, "Open Sans", "Rubik", system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
	}
	.cov-date-box {
		background: #fff;
	}
	.cov-date-caption {
		margin: -50px 0px !important;
	}
	.week ul li {
		width: 14% !important;
	}
	.datePicked .resetButtton {
		position: absolute;
		right: 10px;
		font-size: 22px;
		cursor: pointer;
		height: 20px;
		line-height: 1;
	}
	.datePicked {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldDatetime.vue